import { getPartnerOnClientSide } from "@tm/insurance/utils";
import { PARTNER } from "@tm/isomorphic-utils";
import { useEffect, useState } from "react";
import { GIInsuranceHeader } from "../static/components/GIInsuranceHeader";
import { MMTInsuranceHeader } from "../static/components/MMTInsuranceHeader";
// import { MyPartnerInsuranceHeader } from "../static/components/MyPartnerInsuranceHeader";

interface PartnerHeaderOptions {
  exitWebViewOnBack?: boolean;
  showPwaHeader?: boolean;
  showPwaHeaderBackButton?: boolean;
  mobileTitle?: string;
}

export function withPartnerInsuranceHeader(
  component: JSX.Element,
  options: PartnerHeaderOptions = {}
) {
  let headerComponent = null;
  const [partnerHeader, setPartnerHeader] = useState("");

  useEffect(() => {
    const partner = getPartnerOnClientSide();
    setPartnerHeader(partner);
  }, []);

  if (partnerHeader === PARTNER.MMT) {
    headerComponent = <MMTInsuranceHeader {...options} />;
  } else if (partnerHeader === PARTNER.GI) {
    headerComponent = <GIInsuranceHeader />;
    // } else if (partnerHeader === PARTNER.MYPARTNER) {
    //   headerComponent = <MyPartnerInsuranceHeader />;
  }

  if (headerComponent) {
    return (
      <>
        {headerComponent}
        {component}
      </>
    );
  }

  return <>{component}</>;
}
